import React from 'react';

import { reduxActions, RootState } from '../../store'
import { connect, ConnectedProps } from 'react-redux'

import { withRouter, RouteComponentProps, Switch, Route } from 'react-router-dom';

import TopbarMenu from './TopbarMenu/TopbarMenu';
import SidebarMenu from './SidebarMenu/SidebarMenu';

import usersService from '../../services/users.service';
import { SessionState } from '../../store/session/types';
import { Toast } from 'primereact/toast';
import NotFound from '../ErrorPages/NotFound/NotFound';
import routes from '../../routes';
import RoutingManager from './RoutingManager/RoutingManager';
import Breadcrumbs from './Breadcrumb/Breadcrumb';

import { AbilityContext } from '../../shared/CASL/can';
import Unauthorized from '../ErrorPages/Unauthorized/Unauthorized';
import rolesService from '../../services/roles.service';
import featuresService from '../../services/features.service';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { Refreshable } from 'react-router-refreshable';
import arxeiaConfigurationsService from '../../services/arxeiaConfigurations.service';
import uorsService from '../../services/uors.service';
import peripheralService from '../../services/peripheral.service';

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    isMobile: state.sessionReducer.isMobile,
    isTablet: state.sessionReducer.isTablet,
    sidebarMenuIsOpen: state.sessionReducer.sidebarMenuIsOpen,
    aooMenuIsOpen: state.sessionReducer.aooMenuIsOpen,
})

const mapDispatch = {
    updateSession: (newSessionState: Partial<SessionState>) => (reduxActions.sessionActions.updateSession(newSessionState)),
    setPreviousLocationPathName: (previousLocationPathName: string) => (reduxActions.appNavigationActions.setPreviousLocationPathName(previousLocationPathName)),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface LayoutProps {
}
type Props = LayoutProps & RouteComponentProps & PropsFromRedux



export interface LayoutState {
}

export const toastRef = React.createRef<Toast>();
class Layout extends React.Component<Props, LayoutState> {

    state = {
    }


    componentDidMount() {
        this.setLayoutProperties();

        usersService.getUserInfo()
            .then(user => {
                rolesService.getAllRoles()
                    .then(roles => {
                        //this.setState({ allRoles: roles });
                        this.props.updateSession({ currentUser: user, allRoles: roles });
                        this.getFeatures();
                        this.getArxeiaConfigurations();

                    });

            });


    }

    componentDidUpdate(oldProps: Props, oldState: LayoutState) {
        if (oldProps.currentAoo !== this.props.currentAoo) {
            this.getOrganigrammaAooFlat();
        }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.props.setPreviousLocationPathName(this.props.location.pathname)
        }
    }

    getFeatures() {
        featuresService.getFeatures()
            .then(features => {
                this.props.updateSession({ features: features });
            });
    }
    getArxeiaConfigurations() {
        arxeiaConfigurationsService.getArxeiaConfigurations()
            .then(configurations => {
                this.props.updateSession({ arxeiaConfigurations: configurations });
            });
    }

    getOrganigrammaAooFlat() {
        if (this.props.currentAoo) {
            uorsService.getOrganigrammaFlat(this.props.currentAoo!.id)
                .then(uors => {
                    this.props.updateSession({ organigrammaFlat: uors });
                });
        }
    }

    setLayoutProperties() {

        const width = window.innerWidth;
        let tablet = width < 1024 && width >= 640;
        let mobile = width < 640;
        let sidebarMenuOpen = tablet === true || mobile === true ? false : true
        this.props.updateSession({ isTablet: tablet, isMobile: mobile, sidebarMenuIsOpen: sidebarMenuOpen });
    }



    render() {
        let layoutWrapperClasses = "layout-wrapper layout-menu-static";
        if (this.props.sidebarMenuIsOpen === false) {
            layoutWrapperClasses = "layout-wrapper layout-menu-static layout-menu-static-inactive";
        }

        let isErrorPage = this.props.location.pathname === "/notfound" || this.props.location.pathname === "/unauthorized";

        return (
            <React.Fragment>
                <Toast ref={toastRef} baseZIndex={1000000} />
                {!this.props.currentAoo && !isErrorPage &&
                    <div style={{ position: 'relative', height: '100%' }}>
                        <CircleLoader loaderClass='loader-large' loading={true} />
                    </div>
                }
                <div className={layoutWrapperClasses}>

                    <div className="layout-navigation-menu" >
                        <TopbarMenu />
                        <SidebarMenu />
                    </div>

                    <div className="layout-content">
                        <Refreshable>
                            <Switch>
                                <Route path="/notfound" component={NotFound} />
                                <Route path="/unauthorized" component={Unauthorized} />
                                {routes.map(({ path, Component, key, exact }) => (


                                    <Route path={path} key={key} exact={exact}
                                        render={props => {
                                            return (
                                                <React.Fragment>
                                                    <RoutingManager />
                                                    <Breadcrumbs {...props} />
                                                    <Component {...props} />
                                                </React.Fragment>
                                            );
                                        }}
                                    >
                                    </Route>

                                ))}
                                <Route component={NotFound} />
                            </Switch>
                        </Refreshable>
                    </div>
                </div >
                {/* <div className="loader opacity active " >
            <CircleLoader />
        </div> */}
            </React.Fragment>
        );
    }
}


export default connector(withRouter(Layout));


Layout.contextType = AbilityContext;

